export const loadState = (key = 'areaPulseAppState') => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (key = 'areaPulseAppState', state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(key, serializedState);
  } catch (err) {
    // Ignore write errors.
  }
};

export const getAuthToken = () => {
  const appState = loadState("areaPulseAppState");
  return appState?.userAuthToken;
};

export const clearLegacyAuthToken = () => {
  try {
    localStorage.removeItem("areaPulseUserToken");
  } catch (err) {
    // Ignore write errors.
  }
};
